/**
 * 模块名称: 招聘管理模块
 * @author zhuyan@372163.com
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Recruits from './Recruits'
import RecruitsDetail from './RecruitsDetail'

const RecruitIndex = ({ match, history }) => {

  return (
    <div>
      <Switch>
        <Route path={match.path + '/detail'} component={RecruitsDetail} />
        <Route component={Recruits} />
      </Switch>
    </div>
  )
}

export default RecruitIndex